export default __webpack_public_path__ + "static/rec-2012-i-1fc02dbe0714a0a7d257cd2aba2204e2.png";